import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { ZodError } from 'zod';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extract field-level error messages from a Zod validation error.
 *
 * Returns a flat `Record<string, string>` keyed by the first path segment
 * of each issue, suitable for displaying inline form errors.
 */
export function extractZodFieldErrors(error: ZodError): Record<string, string> {
  const fieldErrors: Record<string, string> = {};
  error.issues.forEach((issue) => {
    const key = issue.path[0]?.toString();
    if (key) fieldErrors[key] = issue.message;
  });
  return fieldErrors;
}
